import React, { useState, useContext, useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';
import ButtonComp from 'atoms/Buttons/Presentation/ButtonComp';
import { InputBox } from 'atoms/InputBox';
import { AnchorWithLink } from 'atoms/Anchor';
import { UserOrderContext } from 'context/context';
import START_ORDER_CONSTANTS from '../../StartOrderComponent/Constants/startOrderConstants';
import SCHEDULE_ORDER_SAMPLE_DATA from '../Data/SampleData';
import SingleArrow from 'styles/staticAssets/images/dropdownArrowBlack.svg';
import Calendar from 'styles/staticAssets/images/Calendar.svg';
import Error from 'styles/staticAssets/images/Error.svg';
import { getDateFromTime, getList } from '../ScheduleOrderUtils/ScheduleOrderUtils';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAvailableTimeSlotsApiSaga,
  getStoreStatusForTimeSaga,
  clearStoreTimeSlotAction,
  orderReadyDateTimeUpdate,
} from '@kfc-global/react-shared/redux/Actions/StoresAction';
import {
  parseInvalidDateAndFormat,
  formatDateTime,
  getEpochTime,
  getCurrentDateTime,
  compareDateTime,
  currentDateTimeInFormat,
} from 'common/utilities/dayJsUtils';
import {
  isEmptyObject,
  getDispositionTypeOnAPIFormat,
  isEmptyEvery,
  setSearchStoreByAtrribute,
  openClearCartModal,
  createBasketData,
  getValueOrDefaultObject,
  isMobileDevice,
  getValueOrDefaultAlternativeObject,
  getEmbeddedErrorMessageAnalytic,
  getTernaryValue,
  getDispositionFomatForSelectContent,
  getAndCheck,
  getValueOrDefaultArray,
} from 'common/utilities/utils';
import { withRouter } from 'react-router-dom';
import { setUserParams } from '@kfc-global/react-shared/redux/Actions/AppStateAction';
import SearchStoreConstants from '../../SearchStore/Constants/SearchStoreConstants';
import ImageComponent from 'atoms/Image';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { createBasketsAction, qrCodeScanTimeAction } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { ChannelManager } from 'common/manager';
import { getScheduleOrderEmbeddedErrorMgsAnalyticFn } from 'components/checkout/CheckoutFn';
import { ASAP, DISPOSITION_TYPES_TEXT } from 'common/constants/SharedConstants';
import { orderLaterAnalyticsData } from '../../SearchStore/AU/SearchStoreUtilities/SearchStoreUtils';
import { changeOrderAnalyticsHandler } from '../../StartOrderComponent/StartOrderUtilities/startOderUtils';

const checkIfInPLPOrPDP = (location, MENU_URL, PDP_URL) => {
  return location?.pathname.indexOf(MENU_URL) === -1 && location?.pathname.indexOf(PDP_URL) === -1;
};
export const getTimeIfASAP = selectedTime => {
  return selectedTime !== 'ASAP' && selectedTime !== '-'
    ? selectedTime
    : parseInvalidDateAndFormat(getCurrentDateTime(), SearchStoreConstants.HHMM, SearchStoreConstants.LT);
};
const getPostBody = (selectedTime, epochFormat) => {
  let postBody = {};
  if (selectedTime !== '-' && selectedTime !== 'ASAP') {
    postBody = {
      isForNow: false,
      futureDateTime: epochFormat,
    };
  } else if (selectedTime === 'ASAP') {
    postBody = {
      isForNow: true,
      futureDateTime: 0,
    };
  }
  return postBody;
};
/* check for what time needs to be displayed from dropdown */
const checkForDisplayTimeDropdown = (
  changeFlow,
  selectedTimeStorage,
  initialDayStartTime,
  date,
  savedTime,
  handleTime,
) => {
  if (changeFlow && selectedTimeStorage) {
    // if the already saved time is in past of the new store selected intial time
    const time24HrsFormat = parseInvalidDateAndFormat(selectedTimeStorage, 'h:mm A', 'HH:mm');
    const selectedFromStorage = new Date(date).setHours(
      Number(time24HrsFormat?.split(':')[0]),
      Number(time24HrsFormat?.split(':')[1]),
      0,
    );
    if (
      selectedFromStorage <
      new Date().setHours(Number(initialDayStartTime?.split(':')[0]), Number(initialDayStartTime?.split(':')[1]), 0)
    ) {
      handleTime(savedTime);
    } else {
      handleTime(selectedTimeStorage);
    }
  }
};
/**
 * get availabletimeslotapisaga on initial render
 */
const getAvailableTimeSlotsFunction = (futureDates, scheduleOrderData, dispositionVal, dispatch, tenantReducer) => {
  if (futureDates.length !== 1) {
    const payload = {
      storeid: scheduleOrderData?.storeInfo?.id,
      channel: ChannelManager.channel,
      service: getDispositionTypeOnAPIFormat(dispositionVal()).toString().toLowerCase(),
      date: '',
    };
    dispatch(
      getAvailableTimeSlotsApiSaga({
        data: payload,
        tenantId: tenantReducer?.tenantId,
      }),
    );
  }
};
const dispositionValText = (changeFlow, isAddressFlow, dispositionValue) => {
  let dispositionLocal = JSON.parse(localStorage.getItem('dispositionNew'));
  if (changeFlow && dispositionLocal) {
    return getDispositionFomatForSelectContent(dispositionLocal.type);
  } else if (isAddressFlow) {
    return DISPOSITION_TYPES_TEXT.PICKUP;
  } else {
    return getDispositionFomatForSelectContent(dispositionValue);
  }
};
/**
 * Header Menu Form
 * @param {*} props - Object
 */
export const ScheduleOrderForm = props => {
  const calenderRef = useRef(null);
  const timeRef = useRef(null);
  const { formContent, location, onStoreSelectFinish } = props;
  const {
    orderTypeTitle = '',
    dateTitle = '',
    timeTitle = '',
    editTitle = '',
    restaurantTitle = '',
    yourLocationTitle = '',
    scheduleDateTitle = '',
    buttonText = '',
  } = formContent;
  const {
    SEARCH_ORDER_DATA,
    SCHEDULE_ORDER_DATA,
    DISPOSITION_DATA,
    SCHEDULE_ORDER_TIME_DATA,
    CLOSED,
    SCHEDULE_ORDER_TIME_PRESERVE_TIME,
    MENU_URL,
    PDP_URL,
    SELECTED_TILE_DATA,
    DISPOSITION_METHOD,
    SET_DISPOSITION,
    USER_LOCALIZED,
    SHOW_CLEAR_CART_ALERT,
    CLEAR_CART_CONFIRM_CANCEL_MODAL,
    clearCartChangeFlag,
    orderTypeAlertTitle,
    searchStoreAlertTitle,
    CURRENT_STORE_INFO,
    SET_FORCERELOAD,
  } = START_ORDER_CONSTANTS;
  const { contentData, timingsSampleData } = SCHEDULE_ORDER_SAMPLE_DATA;
  const profileReducer = useSelector(data => data.profileReducer);
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { dispositionStateData = {}, scheduleOrderData = {} } = userOrderState;
  const { changeFlow = false, isAddressFlow = false } = scheduleOrderData;
  const selectedStoreInfo =
    scheduleOrderData && isEmptyObject(scheduleOrderData.storeInfo)
      ? scheduleOrderData.storeInfo
      : JSON.parse(localStorage.getItem('storeInfo'));
  const { dispositionType = '' } = dispositionStateData;
  const dispositionValue = dispositionType ? dispositionType : localStorage.getItem('dispositionType');
  const { value: storeName = '' } = (scheduleOrderData?.storeInfo?.name[0]) || { value: '' };
  const { date = '' } =
    scheduleOrderData && scheduleOrderData.selectedDateTimeInfo?.date?.length > 0
      ? scheduleOrderData.selectedDateTimeInfo
      : JSON.parse(localStorage.getItem('dateTimeOrder')) || { date: '' };
  const savedTime =
    scheduleOrderData && scheduleOrderData.selectContentData?.savedTime?.length > 0
      ? scheduleOrderData.selectContentData?.savedTime
      : localStorage.getItem('savedTimeOrder');
  /* handling timing if storeInfo is null & added it specially for delivery flow*/
  const {
    futureDates,
    scheduled: initiallyScheduled,
    asap,
  } = scheduleOrderData.storeInfo?.summary?.timings || timingsSampleData;
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;
  const { unavailibilities } = initiallyScheduled;
  const { interval: initialInterval = 0, startEndTime = {} } =
    initiallyScheduled && initiallyScheduled.periods.length && initiallyScheduled.periods[0];
  const { from: initialDayStartTime, to: initialDayEndTime } = startEndTime;
  let userParams = useSelector(data => data.appStateReducer.userStatus);
  const dispatch = useDispatch();
  const tenantReducer = useSelector(data => data.tenantReducer);
  const storesReducer = useSelector(data => data.storesReducer);
  const cartReducer = useSelector(data => data.cartReducer);
  const { cartData } = cartReducer;
  const { storesAvilableTimeSlots, storesTimeSlots } = storesReducer;
  const [confirmFlag, setConfirmFlag] = useState(false);
  const {
    errorMessageInactive = '',
    errorMessageClosed = '',
    SWITCH_TO_TAKEAWAY,
    DELIVERY_NA_WARNING_MESSAGE,
    DELIVERY_PICKUP_NA_MESSAGE,
    scheduleOrderHeaderText,
    changeScheduleOrderHeaderText,
  } = contentData;
  const [hasError, setHasError] = useState({ error: false, errormessage: '' });
  const [timeInfo, setTimeInfo] = useState({
    from: initialDayStartTime,
    to: initialDayEndTime,
    interval: initialInterval,
  });

  const onEditStore = () => {
    if (cartData?.foodLines?.length > 0) {
      //open clear cart alert
      let modalOpenObj = { flag: clearCartChangeFlag, onConfirm: searchStoreAlertTitle };
      openClearCartModal(userOrderStateDispatch, modalOpenObj, SHOW_CLEAR_CART_ALERT, CLEAR_CART_CONFIRM_CANCEL_MODAL);
    } else {
      let locationStorage = getValueOrDefaultArray(JSON.parse(localStorage.getItem('seachedLocations')));
      if (isAddressFlow) {
        userOrderStateDispatch({
          type: SEARCH_ORDER_DATA,
          value: { showSearchStore: true, searchedPlaceNonLocalized: scheduleOrderData.storeInfo.name[0].value },
        });
      } else if (locationStorage) {
        let searchedLocation = locationStorage[locationStorage.length - 1];
        userOrderStateDispatch({
          type: SEARCH_ORDER_DATA,
          value: { showSearchStore: true, searchedPlaceNonLocalized: searchedLocation },
        });
      }
    }

    userOrderStateDispatch({
      type: SCHEDULE_ORDER_DATA,
      value: {
        showScheduleOrderCatering: false,
        changeFlow: Boolean(changeFlow),
      },
    });

    userOrderStateDispatch({
      type: DISPOSITION_METHOD,
      value: {
        dispositionType: dispositionVal(),
      },
    });
  };
  const onEditDisposition = () => {
    if (cartData && cartData?.foodLines?.length > 0) {
      //open clear cart alert
      let modalOpenObj = { flag: clearCartChangeFlag, onConfirm: orderTypeAlertTitle };
      openClearCartModal(userOrderStateDispatch, modalOpenObj, SHOW_CLEAR_CART_ALERT, CLEAR_CART_CONFIRM_CANCEL_MODAL);
    } else {
      userOrderStateDispatch({
        type: DISPOSITION_DATA,
        value: { showDisposition: true },
      });
    }
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_DATA,
      value: { showScheduleOrderCatering: false },
    });
    userOrderStateDispatch({
      type: SEARCH_ORDER_DATA,
      value: { showSearchStore: false },
    });
  };

  const isOrderTypeDelivery = () => {
    if (changeFlow) {
      return (
        JSON.parse(localStorage.getItem('dispositionNew'))?.type.toUpperCase() === SearchStoreConstants.TYPE_DELIVERY
      );
    } else if (isAddressFlow) {
      return false;
    } else {
      return dispositionValue?.toUpperCase() === SearchStoreConstants.TYPE_DELIVERY;
    }
  };

  const [selectedDate, setSelectedDate] = new useState(
    initiallyScheduled && initiallyScheduled.date ? new Date(initiallyScheduled.date.toString()) : new Date(),
  );
  const [selectedTime, setSelectedTime] = new useState(
    asap && asap.isAvailable ? 'ASAP' : parseInvalidDateAndFormat(startEndTime?.from, 'hh:mm', 'LT'),
  );
  const [timeList, setTimeList] = useState([]);
  const [timeListFlag, setTimeListFlag] = useState(false);
  const [datePickerIsOpen, setDatePickerIsOpen] = useState(false);

  const [isMobileView, setMobileHeader] = useState(isMobileDevice(window.innerWidth));

  const windowResized = () => {
    setMobileHeader(isMobileDevice(window.innerWidth));
  };

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobileView]);

  useEffect(() => {
    if (futureDates.length === 1 && tenantReducer?.country === 'INDIA') {
      const payload = {
        storeid: scheduleOrderData?.storeInfo?.id,
        channel: ChannelManager.channel,
        service: getDispositionTypeOnAPIFormat(dispositionVal()).toString().toLowerCase(),
        date: '',
      };
      dispatch(
        getAvailableTimeSlotsApiSaga({
          data: payload,
          tenantId: tenantReducer.tenantId,
        }),
      );
    }
    let arr = getList(
      initialDayStartTime,
      initialDayEndTime,
      initialInterval,
      asap?.isAvailable,
      futureDates.length === 1 && tenantReducer?.country === 'INDIA',
      unavailibilities,
    );
    setTimeList(arr);
    return () => {
      dispatch(clearStoreTimeSlotAction());
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dateChangeHandler = val => {
    // for INDIA date selection will be disabled
    if (tenantReducer?.country === 'INDIA') {
      return;
    }
    const dateVal = formatDateTime(val, 'YYYY-MM-DD');
    if (initiallyScheduled.date === dateVal) {
      let arr = getList(
        initialDayStartTime,
        initialDayEndTime,
        initialInterval,
        asap?.isAvailable,
        futureDates.length === 1 && tenantReducer?.country === 'INDIA',
        unavailibilities,
      );

      setTimeList(arr);
      setSelectedTime(arr[0].timestr);
      setTimeInfo({
        from: initialDayStartTime,
        to: initialDayEndTime,
        interval: initialInterval,
      });
      setSelectedDate(val);

      setHasError({
        ...hasError,
        error: false,
        errormessage: '',
      });
      setTimeListFlag(false);
      setDatePickerIsOpen(false);
      return;
    }
    const payload = {
      storeid: scheduleOrderData?.storeInfo?.id,
      channel: ChannelManager.channel,
      service: getDispositionTypeOnAPIFormat(dispositionVal()).toString().toLowerCase(),
      dateVal,
    };
    dispatch(
      getAvailableTimeSlotsApiSaga({
        data: payload,
        tenantId: tenantReducer.tenantId,
      }),
    );
    setSelectedDate(val);
    if (storesAvilableTimeSlots?.periods?.length > 0) {
      const { startEndTime: startEndTimeVal, interval } = storesAvilableTimeSlots.periods[0];
      const { from, to } = startEndTimeVal;
      let arr = getList(
        from,
        to,
        interval,
        asap?.isAvailable,
        futureDates.length === 1 && tenantReducer?.country === 'INDIA',
        unavailibilities,
      );
      setTimeInfo({ from, to, interval });
      setTimeList(arr);
    }

    setHasError({
      ...hasError,
      error: false,
      errormessage: '',
    });
  };

  const isToday = dateargs => {
    const today = new Date();
    const someDate = new Date(dateargs.split('T')[0]);
    return (
      someDate.getDate() === today.getDate() &&
      someDate.getMonth() === today.getMonth() &&
      someDate.getFullYear() === today.getFullYear()
    );
  };

  const getTimeValue = timeargs => {
    if (timeargs?.timestr) {
      return timeargs?.timestr;
    }
    return timeargs;
  };

  const handleTime = time => {
    setSelectedTime(time === 'ASAP' ? 'ASAP' : getTimeValue(time));
    let dateAccordingToTime = getDateFromTime(
      initialDayStartTime,
      time?.selectedDay ? time : { timestr: time, selectedDay: isToday(date) ? 'Today' : 'Tomorrow' },
    );
    setSelectedDate(dateAccordingToTime);

    setTimeListFlag(false);
    setDatePickerIsOpen(false);

    setHasError({
      ...hasError,
      error: false,
      errormessage: '',
    });
  };

  useEffect(() => {
    const selectedTimeStorage = savedTime;
    if (date) {
      dateChangeHandler(new Date(date));
    }

    checkForDisplayTimeDropdown(changeFlow, selectedTimeStorage, initialDayStartTime, date, savedTime, handleTime);
    getAvailableTimeSlotsFunction(futureDates, scheduleOrderData, dispositionVal, dispatch, tenantReducer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let popupTitle = getTernaryValue(
      changeFlow,
      translateWithI18Next(changeScheduleOrderHeaderText),
      translateWithI18Next(scheduleOrderHeaderText),
    );
    if (isEmptyObject(storesTimeSlots) && confirmFlag) {
      if (storesTimeSlots?.status?.currentStatus === CLOSED) {
        setHasError({
          ...hasError,
          error: true,
          errormessage: translateWithI18Next(errorMessageClosed),
        });
        getEmbeddedErrorMessageAnalytic(popupTitle, translateWithI18Next(errorMessageClosed));
      } else {
        let current = new Date();
        if (new Date(selectedDate).setHours(0, 0, 0, 0) === current.setHours(0, 0, 0, 0)) {
          let currentTime = getCurrentDateTime();
          let afterAddingPromise = currentTime.add(asap.promiseTime, 'minutes').format('LT');
          if (compareDateTime(afterAddingPromise, selectedTime, 'h:mm A')) {
            setHasError({
              ...hasError,
              error: true,
              errormessage: translateWithI18Next(errorMessageInactive),
            });
            getEmbeddedErrorMessageAnalytic(popupTitle, translateWithI18Next(errorMessageInactive));
          } else {
            checkIfInPLPOrPDP(location, MENU_URL, PDP_URL) ? goToMenu() : updateSelectContent();
          }
        } else {
          checkIfInPLPOrPDP(location, MENU_URL, PDP_URL) ? goToMenu() : updateSelectContent();
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storesTimeSlots, profileReducer]);

  const goToMenu = () => {
    userOrderStateDispatch({ type: SELECTED_TILE_DATA, value: { selectedData: {} } });
    localStorage.setItem('tenantReducer', JSON.stringify(tenantReducer));
    localStorage.setItem('selectedTile', JSON.stringify({}));
    updateSelectContent();
    setTimeout(() => {
      props.history.push({
        pathname: `${MENU_URL}`,
      });
    }, 500);
  };

  const updateSelectContent = async () => {
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_DATA,
      value: {
        showScheduleOrderCatering: false,
        selectedStoreInfo: scheduleOrderData?.storeInfo,
        changeFlow: true,
      },
    });
    userOrderStateDispatch({
      type: DISPOSITION_METHOD,
      value: { dispositionType: dispositionValue },
    });

    localStorage.setItem('dispositionType', dispositionVal());
    localStorage.setItem(
      'storeInfo',
      scheduleOrderData?.storeInfo
        ? JSON.stringify(scheduleOrderData.storeInfo)
        : JSON.stringify({}),
    );
    localStorage.setItem(
      'currentStoreInfo',
      scheduleOrderData?.storeInfo
        ? JSON.stringify(scheduleOrderData.storeInfo)
        : JSON.stringify({}),
    );
    userOrderStateDispatch({
      type: CURRENT_STORE_INFO,
      value: getValueOrDefaultObject(scheduleOrderData?.storeInfo),
    });
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
    let time = '',
      timeToRetain = '';
    if (selectedTime === 'ASAP' || selectedTime === '-') {
      time = 'ASAP';
      timeToRetain = 'ASAP';
    } else {
      time = selectedTime;
      timeToRetain = selectedTime;
    }
    userOrderStateDispatch({
      type: SET_FORCERELOAD,
      value: { forceReload: true },
    });
    let dateTimeObj = { time: time, interval: timeInfo.interval, date: selectedDate, selectedTime };
    if (
      dispositionNew === null ||
      dispositionNew.type !== dispositionVal() ||
      dispositionNew.store.id !== selectedStoreInfo.id ||
      dispositionNew.deliveryAddress !== scheduleOrderData.deliveryAddress
    ) {
      let obj = await createBasketData(
        selectedStoreInfo,
        getDispositionTypeOnAPIFormat(dispositionValue),
        profileReducer.customerId,
        dateTimeObj,
        scheduleOrderData?.deliveryAddress,
        scheduleOrderData?.deliveryAddressLine,
      );
      dispatch(qrCodeScanTimeAction(''));
      dispatch(createBasketsAction({ data: obj, tenantId: tenantReducer.tenantId }));
    }
    dispatch(
      setUserParams({
        ...userParams,
        localized: true,
      }),
    );
    userOrderStateDispatch({
      type: SET_DISPOSITION,
      value: {
        oldvalue: dispositionNew,
        newValue: {
          type: dispositionVal(),
          store: selectedStoreInfo,
          date: dateTimeObj.date,
          time: dateTimeObj.time,
          interval: dateTimeObj.interval,
          selectedTime: dateTimeObj.selectedTime,
          deliveryAddress: scheduleOrderData?.deliveryAddress,
        },
      },
    });
    localStorage.setItem('dispositionOld', JSON.stringify(dispositionNew));
    localStorage.setItem(
      'dispositionNew',
      JSON.stringify({
        type: dispositionVal(),
        store: selectedStoreInfo,
        date: dateTimeObj.date,
        time: dateTimeObj.time,
        interval: dateTimeObj.interval,
        selectedTime: dateTimeObj.selectedTime,
        deliveryAddress: scheduleOrderData?.deliveryAddress,
      }),
    );
    setSearchStoreByAtrribute();
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_TIME_DATA,
      value: { selectedDateTime: dateTimeObj },
    });
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_TIME_PRESERVE_TIME,
      value: { selectContentTime: timeToRetain },
    });
    localStorage.setItem('dateTimeOrder', JSON.stringify(dateTimeObj));
    localStorage.setItem('savedTimeOrder', timeToRetain);
  };

  /**
   * Method to handle error on confirmation
   */
  const onConfirmHandler = e => {
    e.stopPropagation();
    e.preventDefault();
    const payloadData = {
      storeID: selectedStoreInfo?.id,
      disposition: dispositionValue,
      postCode: selectedStoreInfo?.addresses[0]?.address?.pinCode,
    };
    onStoreSelectFinish(payloadData);
    orderLaterAnalyticsData(payloadData, selectedTime);
    changeOrderAnalyticsHandler(scheduleOrderData);
    setConfirmFlag(true);
    let timeIfAsap = getTimeIfASAP(selectedTime);
    const epochFormat = getEpochTime(
      formatDateTime(selectedDate, 'YYYY-MM-DD') + ' ' + timeIfAsap,
      'YYYY-MM-DD hh:mm A',
    );
    const payload = {
      storeid: scheduleOrderData?.storeInfo?.id,
      channel: ChannelManager.channel,
      service: getDispositionTypeOnAPIFormat(dispositionVal()).toString().toLowerCase(),
      futureDateTimeInEpochFormat: epochFormat,
      asap: selectedTime === ASAP,
    };
    dispatch(getStoreStatusForTimeSaga({ data: payload, tenantId: tenantReducer.tenantId }));
    // Update date and Time
    if (cartData?.id) {
      dispatch(
        orderReadyDateTimeUpdate({
          params: { basketId: cartData?.id },
          tenantId: tenantReducer.tenantId,
          postBody: getPostBody(selectedTime, epochFormat),
        }),
      );
    }
    userOrderStateDispatch({
      type: USER_LOCALIZED,
      value: { isLocalized: true },
    });
  };

  useEffect(() => {
    let obj = {
      startEndTime: {
        from: '',
        to: '',
      },
      interval: '',
    };

    if (Object.keys(storesAvilableTimeSlots || {}).length === 2) {
      // pastmidnight order case
      const { startEndTime: startEndTimeForToday, interval } = getValueOrDefaultAlternativeObject(
        storesAvilableTimeSlots[0]?.periods[0],
        obj,
      );
      const { startEndTime: startEndTimeForTomorrow } = getValueOrDefaultAlternativeObject(
        storesAvilableTimeSlots[1]?.periods[0],
        obj,
      );
      const { from } = startEndTimeForToday;
      const { to } = startEndTimeForTomorrow;
      let arr = getList(
        from,
        to,
        interval,
        asap?.isAvailable,
        futureDates.length === 1 &&
          new Date(storesAvilableTimeSlots[0]?.date).setHours(0, 0, 0, 0) <
            new Date(futureDates?.[0]).setHours(0, 0, 0, 0) &&
          tenantReducer?.country === 'INDIA',
        unavailibilities,
      );
      setTimeInfo({ from, to, interval });
      setTimeList(arr);
      checkForClosedStoreTime(arr, savedTime, handleTime);
      if (!storesAvilableTimeSlots.find(item => item.date === date.split('T')[0])) {
        setSelectedDate(new Date(storesAvilableTimeSlots[0]?.date));
      }
    } else if (Object.keys(storesAvilableTimeSlots || {}).length) {
      // normal Case
      const { startEndTime: startEndTimeData, interval } = getValueOrDefaultAlternativeObject(
        storesAvilableTimeSlots[0]?.periods[0],
        obj,
      );
      const { from, to } = startEndTimeData;
      let arr = getList(
        from,
        to,
        interval,
        asap?.isAvailable,
        tenantReducer?.country === 'INDIA' &&
          futureDates.length === 1 &&
          new Date(storesAvilableTimeSlots[0]?.date).setHours(0, 0, 0, 0) <
            new Date(futureDates?.[0]).setHours(0, 0, 0, 0),
        unavailibilities,
      );
      setTimeInfo({ from, to, interval });
      setTimeList(arr);

      checkForClosedStoreTime(arr, savedTime, handleTime);

      if (!storesAvilableTimeSlots.find(el => el.date === date.split('T')[0])) {
        setSelectedDate(new Date(storesAvilableTimeSlots[0]?.date));
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(storesAvilableTimeSlots)]);

  /* closing the dropdown code */
  const handleClickOutside = event => {
    if (!(calenderRef?.current?.contains(event.target) || timeRef?.current?.contains(event.target))) {
      setTimeListFlag(false);
      setDatePickerIsOpen(false);
    }
  };

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const isDateTomorrow = () => formatDateTime(selectedDate, 'YYYYMMDD') === currentDateTimeInFormat('YYYYMMDD');

  const handleTakeAwaySwitch = () => {
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: true } });
    userOrderStateDispatch({ type: SCHEDULE_ORDER_DATA, value: { showDisposition: false } });
    userOrderStateDispatch({
      type: DISPOSITION_METHOD,
      value: { dispositionType: 'Pickup' },
    });
  };

  const availableServicesForWeb = scheduleOrderData?.storeInfo?.availableServicesPerChannel?.find(
    c => c.channel === 'web',
  )?.services;
  const isDeliveryAvailable = availableServicesForWeb?.includes('delivery');

  const showWaring = getAndCheck(isOrderTypeDelivery(), !isDeliveryAvailable);

  const getWarning = () => {
    let message = translateWithI18Next(DELIVERY_PICKUP_NA_MESSAGE);
    let showTakeWayButton = false;
    if (isDeliveryAvailable) {
      message = translateWithI18Next(DELIVERY_NA_WARNING_MESSAGE);
      showTakeWayButton = true;
    }
    return { showTakeWayButton, message };
  };

  const { message: warningMessage } = getWarning();

  useEffect(() => {
    getScheduleOrderEmbeddedErrorMgsAnalyticFn(changeFlow, warningMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [warningMessage]);

  const WarningComponent = () => {
    const { message, showTakeWayButton } = getWarning();
    return (
      <div className={`alert-delivery-popup w-100 ${showTakeWayButton ? '' : 'alert-without-action-button'}`}>
        <ImageComponent srcFile={Error} className='location-alert-icon' />
        <div className='location-error-message'>{message}</div>
        <div className='location-error-button-section'>
          {showTakeWayButton && (
            <ButtonComp
              className='location-warning-button'
              data-testid='click-handle-away'
              onClickHandler={handleTakeAwaySwitch}
            >
              {translateWithI18Next(SWITCH_TO_TAKEAWAY)}
            </ButtonComp>
          )}
        </div>
      </div>
    );
  };
  const dispositionVal = () => {
    let dispositionLocal = JSON.parse(localStorage.getItem('dispositionNew'));
    if (changeFlow && dispositionLocal) {
      return dispositionLocal.type;
    } else if (isAddressFlow) {
      return 'Pickup';
    } else {
      return dispositionValue;
    }
  };

  const checkDeliveryAddress = changeFlow
    ? JSON.parse(localStorage.getItem('dispositionNew'))?.deliveryAddress
    : scheduleOrderData.deliveryAddress;
  const onEditLocation = () => {
    userOrderStateDispatch({
      type: DISPOSITION_METHOD,
      value: {
        dispositionType: changeFlow ? JSON.parse(localStorage.getItem('dispositionNew')).type : dispositionValue,
      },
    });
    if (cartData && cartData?.foodLines?.length > 0) {
      //open clear cart alert
      let modalOpenObj = { flag: clearCartChangeFlag, onConfirm: searchStoreAlertTitle };
      openClearCartModal(userOrderStateDispatch, modalOpenObj, SHOW_CLEAR_CART_ALERT, CLEAR_CART_CONFIRM_CANCEL_MODAL);
    } else {
      userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: true } });
    }
    userOrderStateDispatch({ type: SCHEDULE_ORDER_DATA, value: { showScheduleOrderCatering: false } });
  };

  return (
    <div className='scheduleOrder-form'>
      <h3 className='order-type'>{translateWithI18Next(orderTypeTitle)}</h3>
      <div className='ordertype-input-div'>
        <InputBox value={dispositionValText(changeFlow, isAddressFlow, dispositionValue)} className='w-100' />
        <div className='edit-input'>
          <AnchorWithLink
            aria-label='Edit order type'
            onClickHandler={onEditDisposition}
            data-testid='edit-disposition-test'
          >
            {translateWithI18Next(editTitle)}
          </AnchorWithLink>
        </div>
      </div>
      {hasError && hasError.error && (
        <div className='error-container'>
          <span className='error-img'></span>
          {hasError.errormessage}
        </div>
      )}
      {isMobileView && showWaring && <WarningComponent />}
      <h3 className='order-type'>
        {isOrderTypeDelivery() ? translateWithI18Next(yourLocationTitle) : translateWithI18Next(restaurantTitle)}
      </h3>
      <div className='ordertype-input-div'>
        <InputBox value={isOrderTypeDelivery() ? checkDeliveryAddress : storeName || ''} className='w-100' />
        <div className='edit-input'>
          {isOrderTypeDelivery() ? (
            <AnchorWithLink
              aria-label='Edit KFC restaurant'
              onClickHandler={onEditLocation}
              data-testid='edit-location-test'
            >
              {translateWithI18Next(editTitle)}
            </AnchorWithLink>
          ) : (
            <AnchorWithLink aria-label='Edit KFC restaurant' onClickHandler={onEditStore} data-testid='edit-store-test'>
              {translateWithI18Next(editTitle)}
            </AnchorWithLink>
          )}
        </div>
      </div>
      {!isMobileView && showWaring && <WarningComponent />}
      <h3 className='order-type'>{translateWithI18Next(scheduleDateTitle)}</h3>
      <div className='schedule-date-time'>
        <div className='schedule-date'>
          <div className='dateTitleDatePicker'>{translateWithI18Next(dateTitle)}</div>
          {futureDates &&
          futureDates.length > 0 &&
          initiallyScheduled &&
          initiallyScheduled.date &&
          tenantReducer?.country !== 'INDIA' ? (
            <React.Fragment>
              <div
                ref={calenderRef}
                onClick={() => setDatePickerIsOpen(!datePickerIsOpen)}
                data-testid='click-date-picker-open'
                className='date-pick'
              >
                <DatePicker
                  selected={selectedDate}
                  showPopperArrow={false}
                  onChange={e => dateChangeHandler(e)}
                  minDate={new Date(initiallyScheduled.date.toString())}
                  maxDate={new Date(futureDates[futureDates.length - 1])}
                  dateFormat='MMMM d, yyyy'
                  className='custom-class'
                  open={datePickerIsOpen}
                  readOnly={true}
                />
                <img src={Calendar} className='date-icon' id='datePickerIcon' alt='Date Icon'/>
              </div>
              <span className='dropdown-img'></span>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className='time-input time-input-container'>
                {(isDateTomorrow() && translateWithI18Next('today') ) || translateWithI18Next('tomorrow')}
              </div>
              {/* <SelectOptions options={['Today']} className='' />
              <span className='dropdown-img'></span> */}
            </React.Fragment>
          )}
        </div>
        <div className='schedule-time'>
          <div className='dateTitleDatePicker' aria-level='1' role='heading' tabIndex='0'>
            {translateWithI18Next(timeTitle)}
          </div>
          <div
            className={timeDropdownClass(timeList)}
            data-testid='time-input-handler'
            role='listbox'
            tabIndex='0'
            onKeyPress={() => initiallyScheduled.periods.length !== 0 && setTimeListFlag(!timeListFlag)}
            onClick={() => initiallyScheduled.periods.length !== 0 && setTimeListFlag(!timeListFlag)}
          >
            <div className='time-input asap-default'>{selectedTime}</div>
            <img src={SingleArrow} alt=' ' className='downarrow-time-list' />
          </div>
          {timeListFlag && (
            <div ref={timeRef} className='schedule-time-list-container'>
              <ul>
                {!!timeList?.length &&
                  timeList.map(item => (
                    <li tabIndex='0' onClick={() => handleTime(item)} onKeyPress={() => handleTime(item)}>
                      {item.timestr}
                    </li>
                  ))}
              </ul>
            </div>
          )}
        </div>
      </div>
      <div className='text-center schedule-btn-div'>
        <ButtonComp
          className='button blackButton confirm-schedule-btn'
          aria-label={translateWithI18Next(buttonText)}
          onClickHandler={onConfirmHandler}
          data-testid='confirm-button-handler'
          disabled={initiallyScheduled.periods.length === 0}
        >
          {translateWithI18Next(buttonText)}
        </ButtonComp>
      </div>
    </div>
  );
};

export default withRouter(ScheduleOrderForm);

function checkForClosedStoreTime(arr, savedTime, handleTime) {
  if (arr) {
    if (!arr.find(timeObj => timeObj?.timestr === savedTime)) {
      handleTime(arr[0]?.timestr);
    }
  } else {
    handleTime('-');
  }
}

export const timeDropdownClass = timeArray => {
  return `time-input-container time-inputbox ${!timeArray?.length ? 'disable-time-dropdown' : ''}`;
};
